// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-container {
  position: relative;
  width: 80px;
  height: 80px;
  margin: auto;
}

.progress-ring {
  transform: rotate(-90deg);
}

.progress-ring__circle {
  transition: stroke-dashoffset 0.6s ease-in-out;
  transform: rotate(0deg);
  transform-origin: center;
}

.progress-ring__background {
  transform: rotate(0deg);
  transform-origin: center;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/progressbar/progress-circle/progress-circle.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,8CAAA;EACA,uBAAA;EACA,wBAAA;AACJ;;AAEE;EACE,uBAAA;EACA,wBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AACJ","sourcesContent":[".circle-container {\n    position: relative;\n    width: 80px;\n    height: 80px;\n    margin: auto;\n  }\n\n  .progress-ring {\n    transform: rotate(-90deg);\n  }\n\n  .progress-ring__circle {\n    transition: stroke-dashoffset 0.6s ease-in-out;\n    transform: rotate(0deg);\n    transform-origin: center;\n  }\n\n  .progress-ring__background {\n    transform: rotate(0deg);\n    transform-origin: center;\n  }\n\n  .progress-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    white-space: nowrap;\n    line-height: 1;\n    text-align: center;\n  }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
